<template>
  <v-container class="mt-0 pt-0" outlined :loading="loading" :disabled="loading">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card outlined>
          <v-card-title>
            <h3>
              <v-icon class="mr-3" color="primary">mdi-format-list-checks</v-icon>Integrações
            </h3>
          </v-card-title>
          <v-card-text>
            <v-row v-if="!loading && integrationCatalog.length">
              <v-col
                v-for="integration in integrationCatalog"
                :key="integration.id"
                cols="12"
                md="4"
              >
                <v-card
                  outlined
                  class="integration-card"
                  @click="openIntegration(integration.slug)"
                >
                  <v-card-title class="subtitle-1">
                    {{ integration.name }}
                  </v-card-title>
                  <v-card-text class="body-2">
                    {{ integration.description }}
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" text>
                      Configurar
                      <v-icon right small>mdi-arrow-right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <div v-else-if="!loading" class="text-center py-6 grey--text">
              Nenhuma integração disponível.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState("configurationIntegration", ["integrationCatalog"]),
  },
  async mounted() {
    await this.loadCatalog();
  },
  methods: {
    ...mapActions("configurationIntegration", ["loadIntegrationCatalog"]),
    async loadCatalog() {
      this.loading = true;
      try {
        await this.loadIntegrationCatalog();
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.loading = false;
    },
    openIntegration(slug) {
      this.$router.push(`/configuration_company/integration/${slug}`);
    },
  },
};
</script>

<style scoped>
.integration-card {
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}

.integration-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
</style>
